import React, { useEffect, useState } from 'react'
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import { FormErrorMessageSpan, InputMintDiv, MobileWebText } from 'views/common-styled-components';
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import InvestmentCalculatorSelector from 'views/calculators/investment-calculators/investment-calculator.selector';
import { useDeepCompare } from 'hooks/use-deep-memo';
import { Col, Row } from 'antd';
import UserSelector from 'views/user/user.selector';
import { useMediaQuery } from 'react-responsive';
import { fetchAgentProfilePic } from '../../views/user/user.actions';
import NoProfilePicture from 'images/no_profile_pic.svg';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
interface InputProps extends React.AllHTMLAttributes<HTMLInputElement> {
    inputLabel: string | React.ReactElement,
    additionalText?: any,
    rules?: Exclude<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>,
    control: Control<any>,
    name: string,
    errors: any,
    variant?: 'line' | 'box',
    handleChange?: Function,
    fontSize?: string,
    defaultAmounts?: any,
}

export const MobileInputBox: React.FC<InputProps> = ({ name, inputLabel, handleChange, defaultValue, fontSize, placeholder, type, disabled, errors, control, id, rules, ...rest }) => {
    return (
        <div>
            <InputMintDiv>
                <label htmlFor={id}>{inputLabel}</label>
                <Controller
                    name={name}
                    type='number'
                    control={control}
                    rules={{
                        ...rules,
                        pattern: {
                            value: /^[6-9]{1}[0-9]{9}$/,
                            message: "Please enter a valid mobile number"
                        }
                    }}
                    render={({ onChange, value }) => (
                        <input
                            id={id}
                            name={name}
                            autoComplete='off'
                            type='number'
                            value={value}
                            disabled={disabled}
                            placeholder={placeholder}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                onChange(event);
                                handleChange && handleChange(event.target.value);
                            }}
                            {...rest}
                        />
                    )}
                />
                {errors[name] ? <FormErrorMessageSpan>{errors[name].message}</FormErrorMessageSpan> : null}
            </InputMintDiv>
        </div>
    );
}
export const EmailInputBox: React.FC<InputProps> = ({ name, inputLabel, handleChange, defaultValue, fontSize, placeholder, type, disabled, errors, control, id, rules, ...rest }) => {
    return (
        <div>
            <InputMintDiv>
                <label htmlFor={id}>{inputLabel}</label>
                <Controller
                    name={name}
                    control={control}
                    rules={{
                        ...rules,
                        pattern: {
                            value: /^.+@[^.].*\.[a-z]{2,}$/,
                            message: "Please enter a valid email"
                        }
                    }}
                    render={({ onChange, value }) => (
                        <input
                            id={id}
                            autoComplete='off'
                            name={name}
                            type='text'
                            value={value}
                            disabled={disabled}
                            placeholder={placeholder}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {                                
                                onChange(event);
                                handleChange && handleChange(event.target.value);
                            }}
                            {...rest}
                        />
                    )}
                />
                {errors[name] ? <FormErrorMessageSpan>{errors[name].message}</FormErrorMessageSpan> : null}
            </InputMintDiv>
        </div>
    );
}

export const NameInputBox: React.FC<InputProps> = ({ name, inputLabel, handleChange, defaultValue, fontSize, placeholder, type, disabled, errors, control, id, rules, ...rest }) => {
    return (
        <InputMintDiv>
            <label htmlFor={id}>{inputLabel}</label>
            <Controller
                name={name}
                control={control}
                rules={{
                    ...rules,
                    pattern: {
                        value: /^[a-zA-Z]+((['. -][a-zA-Z ])?[a-zA-Z]*)*$/,
                        message: "Please enter a valid name"
                    }
                }}
                render={({ onChange, value }) => (
                    <input
                        id={id}
                        autoComplete='off'
                        name={name}
                        type='text'
                        value={value}
                        disabled={disabled}
                        placeholder={placeholder}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            onChange(event);    
                            handleChange && handleChange(event.target.value);
                        }}
                        {...rest}
                    />
                )}
            />
            {errors[name] ? <FormErrorMessageSpan>{errors[name].message}</FormErrorMessageSpan> : null}
        </InputMintDiv>
    );
}

export const CalculatorAdvisor: React.FC = () => {
    const dispatch = useDispatch();
    const { customerFromSharedLinkDetails } = propsToJS(useSelector(InvestmentCalculatorSelector));
    const { agentProfilePic } = propsToJS(useSelector(UserSelector));
    const [profilePicSrc, setProfilePicSrc] = useState<string>(NoProfilePicture);
    const [agentDets, setAgentDets] = useState<any>();
    const isMobile = useMediaQuery({ maxWidth: 767 });

    useEffect(() => {
        if (customerFromSharedLinkDetails) {
            getAgentCertificates();
            dispatch(fetchAgentProfilePic(customerFromSharedLinkDetails?.sharedByAgent));
        }
    }, [useDeepCompare(customerFromSharedLinkDetails)])

    useEffect(() => {
        agentProfilePic?.fileId ? setProfilePicSrc(`${agentProfilePic?.url}/${agentProfilePic.fileId}?broker=turtlemint`) : setProfilePicSrc(NoProfilePicture);
    }, [agentProfilePic])
    const getAgentCertificates =()=>{
        get(ENDPOINTS.GET_AGENT_DETAILS + `/${customerFromSharedLinkDetails?.sharedByAgent}`, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                setAgentDets(response?.response?.responseData);
            }, (error: AjaxError) => {
                console.error(error);
            });
    }

    return (
        <div>
            {(customerFromSharedLinkDetails && agentDets?.advisorName) && <Row justify='end' align='middle'>
                <Col>
                    <img src={profilePicSrc} alt="profile" className='dp_avatar' />
                </Col>
                <Col>
                    <MobileWebText isMobile={isMobile} fonts={[12, 14]}><p className='greyText'>Your advisor</p></MobileWebText>
                    <MobileWebText isMobile={isMobile} fonts={[14, 16]}><strong className='text-ellipsis advisor-name'>{agentDets?.advisorName}</strong></MobileWebText>
                </Col>
            </Row>}
        </div>
    );
}



